<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="用户" text="用户列表">
          <v-layout row wrap class="mx-3">
            <v-layout row wrap xs12>
              <v-flex sm3>
                <v-text-field hide-details label="昵称" v-model="searchNickName"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field hide-details label="手机号" v-model="searchMobile"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-dialog
                  ref="dialog"
                  v-model="dateDialog"
                  :return-value.sync="searchDate"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <v-date-picker v-model="searchDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dateDialog = false">取消</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(searchDate)">确定</v-btn>
                  </v-date-picker>
                </v-dialog>

                <v-text-field
                  hide-details
                  label="创建时间"
                  v-model="searchDate"
                  @click="dateDialog=true"
                ></v-text-field>
              </v-flex>
              <v-flex sm3 class="text-no-wrap">
                <v-btn color="orange" dark class="mx-2" @click="onClickReset">重置</v-btn>
                <v-btn color="green" dark @click="onClickSearch">查询</v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :pagination.sync="pagination"
                :rows-per-page-items="rowsPerPageItems"
                :disable-initial-sort="true"
              >
                <template slot="headerCell" slot-scope="{ header }">
                  <span
                    class="subheading font-weight text-success text--darken-3"
                    v-text="header.text"
                  />
                </template>
                <template slot="items" slot-scope="{ item }">
                  <td>{{ item.id }}</td>
                  <td>{{ item.nickName }}</td>
                  <td>{{ item.mobile }}</td>
                  <td>
                    <img :src="item.avatarUrl" class="avatar">
                  </td>
                  <td>
                    <v-icon v-if="item.gender">{{getGenderIcon(item)}}</v-icon>
                  </td>
                  <td>
                    <v-icon v-if="item.isAdmin" color="green">mdi-check-circle-outline</v-icon>
                  </td>
                  <td>{{ item.wechatUnionID }}</td>
                  <td>{{ formateDate(item.createdAt) }}</td>
                  <td>
                    <v-chip
                      v-if="!item.isAdmin"
                      small
                      color="green"
                      text-color="white"
                      class="pointer"
                      @click="onClickSetAdmin(item)"
                    >设为管理员</v-chip>
                    <v-chip
                      v-else
                      small
                      color="red"
                      text-color="white"
                      class="pointer"
                      @click="onClickUnsetAdmin(item)"
                    >取消管理员</v-chip>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.avatar {
  border-radius: 50%;
  width: 28px;
  height: 28px;
}
</style>


<script>
import global from '@/global'
import dayjs from 'dayjs'
import { getUsersByPage, setAdmin, unsetAdmin } from '@/services'

export default {
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id'
      },
      {
        text: '昵称',
        value: 'nickName'
      },
      {
        text: '手机号',
        value: 'mobile'
      },
      {
        text: '头像',
        value: 'avatarUrl'
      },
      {
        text: '性别',
        value: 'gender'
      },
      {
        text: '是否管理员',
        value: 'isAdmin'
      },
      {
        text: 'UnionID',
        value: 'wechatUnionID',
        sortable: false
      },
      {
        text: '创建时间',
        value: 'createdAt'
      },
      {
        text: '操作',
        value: '',
        sortable: false
      }
    ],
    items: [],
    rowsPerPageItems: [2, 5, 10, 20, 50],
    pagination: {
      page: 1,
      rowsPerPage: 5,
      descending: false,
      sortBy: null
    },
    criteria: [],
    searchMobile: null,
    searchNickName: null,
    searchDate: null,
    dateDialog: false
  }),

  computed: {
    tempParams() {
      return {
        descending: this.pagination.descending || null,
        page: this.pagination.page || null,
        rowsPerPage: this.pagination.rowsPerPage || null,
        sortBy: this.pagination.sortBy || null
      }
    },

    totalItems() {
      return (this.pagination && this.pagination.totalItems) || 0
    }
  },

  watch: {
    tempParams: {
      async handler(oldValue, newValue) {
        // console.log('oldValue', JSON.stringify(oldValue))
        if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
          return
        }
        // console.log('newValue', JSON.stringify(newValue))
        await this.fetchData()
      }
    }
  },

  async beforeMount() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      let pagination = await getUsersByPage({
        ...this.pagination,
        criteria: this.criteria
      })

      if (pagination) {
        // remove items from pagination
        this.pagination = { ...pagination, items: [] }
        this.items = pagination.items
      }
    },

    formateDate(x) {
      return dayjs(x).format('YYYY-MM-DD HH:mm')
    },

    async onClickSearch() {
      let criteria = []
      if (this.searchMobile) {
        criteria.push({
          name: 'mobile',
          op: 'like',
          value: `%${this.searchMobile.replace(/《|》/g, '')}%`
        })
      }

      if (this.searchNickName) {
        criteria.push({
          name: 'nickName',
          op: 'like',
          value: `%${this.searchNickName}%`
        })
      }

      if (this.searchDate) {
        criteria.push({
          name: 'createdAt',
          op: 'between',
          value: dayjs(this.searchDate).format('YYYY-MM-DD'),
          value2: dayjs(this.searchDate).format('YYYY-MM-DD 23:59:59')
        })
      }

      this.criteria = criteria
      await this.fetchData()
    },

    async onClickReset() {
      this.criteria = []
      this.searchMobile = null
      this.searchNickName = null
      this.searchDate = null
      await this.fetchData()
    },

    getGenderIcon(item) {
      if (item.gender === 1) {
        return 'mdi-gender-male'
      }
      if (item.gender === 2) {
        return 'mdi-gender-female'
      }
      return ''
    },

    async onClickSetAdmin(item) {
      let res = await setAdmin(item.id)
      if (res && res.success) {
        await this.fetchData()
        global.showSuccess(res.success)
      }
    },

    async onClickUnsetAdmin(item) {
      let res = await unsetAdmin(item.id)
      if (res && res.success) {
        await this.fetchData()
        global.showSuccess(res.success)
      }
    }
  }
}
</script>
